<script>
    import AudioPlayer from "../../components/audio-player/AudioPlayer.svelte";
    import AudioPageHeader from "../../components/AudioPageHeader.svelte";
    import AudioPageImage from "../../components/AudioPageImage.svelte";
    import AudioPageTitle from "../../components/AudioPageTitle.svelte";
    import { createEventDispatcher } from "svelte";
    import GeneralSliderLayout from "../../../../common/GeneralSliderLayout.svelte";
    import AudioPodcastInfo from "./AudioPodcastInfo.svelte";
    import AudioGuideInfo from "./AudioGuideInfo.svelte";

    export let image;
    export let audio;
    export let headerTitle;
    export let audioInfo;
    export let audioTitle;

    export let podcastId;

    export let showBack = false;
    export let showNext = false;

    export let showHeader = true;

    let dispatch = createEventDispatcher();

    $: showInfo = false;
    $: isPodcast = audioInfo && audioInfo.type === "podcast";

    function onCollapse() {
        console.log("onCollapse");
        showInfo = false;
    }
</script>

<div style="height: 100%;">
    {#if showHeader}
        <div class="display-small">
            <AudioPageHeader
                info={audioInfo}
                title={headerTitle}
                on:actionClicked={() => (showInfo = true)}
                onSite={!isPodcast}
            />
        </div>
        <div style="height:1px;" />
    {/if}
    <GeneralSliderLayout
        slideOpen={showInfo}
        on:collapse={onCollapse}
        slideColor={audioInfo?.background?.color ?? "none"}
        slideTitle={audioTitle}
    >
        <div
            slot="firstSegment"
            class="first-segment"
            style="box-sizing: border-box; width:100%"
        >
            <div class="display-big">
                <AudioPageHeader hideSeperator />
            </div>
            <AudioPageImage {image} />

            <!-- Titles -->
            <div style="margin-top: 40px; overflow:hidden" class="mobile-title">
                {#if audioTitle}
                    <AudioPageTitle title={audioTitle} />
                {/if}
            </div>
            <div style="margin-top: 40px" class="desktop-title">
                {#if headerTitle}
                    <div class="headline-xs top-title">
                        {headerTitle}
                    </div>
                {/if}
                {#if audioTitle}
                    <div class="headline-s">
                        {audioTitle}
                    </div>
                {/if}
            </div>

            <div class="player-spacer" />
            <div style="margin-top: 24px">
                <AudioPlayer
                    on:switchBackwards={() => dispatch("switchBackwards")}
                    on:switchForward={() => dispatch("switchForward")}
                    {showNext}
                    {showBack}
                    {audio}
                />
            </div>
        </div>
        <div slot="secondSegment" class="info-container">
            {#if audioInfo}
                {#if isPodcast}
                    <AudioPodcastInfo {audioInfo} {podcastId} />
                {:else if audioInfo}
                    <AudioGuideInfo {audioInfo} />
                {/if}
            {/if}
        </div>
    </GeneralSliderLayout>
</div>

<style>
    .info-container {
        display: flex;
        flex-direction: column;
        margin: 76px 16px 32px 16px;
    }

    .first-segment {
        display: flex;
        flex-direction: column;
        align-items: stretch;
        padding: 0px 16px 32px 16px;
    }

    .player-spacer {
        flex: 0;
    }

    .mobile-title {
        display: block;
    }

    .desktop-title {
        display: none;
    }

    @media (min-width: 1440px) {
        .first-segment {
            height: 100%;
            justify-content: space-between;
        }

        .player-spacer {
            flex: 10;
        }

        .mobile-title {
            display: none;
        }

        .desktop-title {
            display: block;
            padding-left: 14px;
        }

        .top-title {
            margin-bottom: 4px;
        }

        .info-container {
            display: flex;
            flex-direction: column;
            margin: 34px 16px 32px 16px;
        }
    }
</style>
